import { useTheme } from "../hooks/useTheme.js";
import { THEME_PREFERENCES, THEME_PREFERENCE_LABELS } from "../lib/theme.js";

/**
 * Settings, You: this device's colour scheme as one row of three choices. The
 * preference is per device (ADR-0045), so it sits with the person, not the
 * workspace. The account menu on the rail carries the same picker.
 */
export function ColourSchemeField() {
  const { preference, setPreference } = useTheme();
  return (
    <div className="field" data-testid="settings-colour-scheme">
      <label>Colour scheme</label>
      <span
        role="radiogroup"
        aria-label="Colour scheme"
        className="seg"
        style={{ justifySelf: "start" }}
      >
        {THEME_PREFERENCES.map((option) => (
          <button
            key={option}
            type="button"
            role="radio"
            aria-checked={preference === option}
            className={preference === option ? "on" : undefined}
            onClick={() => setPreference(option)}
          >
            {THEME_PREFERENCE_LABELS[option]}
          </button>
        ))}
      </span>
      <div className="help">
        Per device. Your laptop and your phone can differ. Light is the design of record.
      </div>
    </div>
  );
}
